<template>
  <div  id="Activitypeople">
    <v-header title="三要素鉴权"></v-header>
    <div class="ActivitypeopleCon">
      <div class="contentRight">
        <div class="rightcon">
          <el-row class="search">
            <el-col :span="6" class=""upload-demo floatRight>
              <!-- <el-button type="primary" @click="excel()" class="export floatRight" >导入</el-button> -->
              <el-upload class="upload-demo floatRight" >
                <el-button size="primary" @click="downloadTemp()">下载导入模板</el-button>
              </el-upload>
            </el-col>
            <el-col :span="6" class="">
              <!-- <el-button type="primary" @click="excel()" class="export floatRight" >导入</el-button> -->
              <el-upload class="upload-demo floatRight" :action="fileUrl" :data="uploadData" ref="uploadAgent" :on-success="uploadSuccess" :headers="uploadHeader" :show-file-list='false'>
                <el-button type="primary">导入</el-button>
              </el-upload>
            </el-col>
          </el-row>

          <el-row style="margin-top:15px;">
            <el-col :span="24">
              <el-table class="tableCon"
                        :data="tableData"
                        style="width: 100%"
              >
                <el-table-column
                  align="center"
                  prop="createDate"
                  label="导入时间"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="fileName"
                  label="文件名"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="createUser"
                  label="操作人"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="status"
                  label="导入状态"
                  width='200'
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="remark"
                  label="备注"
                >
                </el-table-column>
                <el-table-column>
                   <template slot-scope="scope">
                    <el-button size="mini" v-if="scope.row.status === 'success'" @click="downloadResult(scope.row)">下载结果</el-button>
                  </template>
                </el-table-column>      
              </el-table>
            </el-col>
            <el-col :span="24" class="pagesize pages" >
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="count">
              </el-pagination>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import url from '@/modules/url'
  import api from '@/modules/api'
  import getIP from '@/components/utils/getIP';
  import vHeader from '@/layout/Header1.vue'
  export default {
    components: {
      vHeader
    },
    name:'auth',
    data () {
      return {
        pageSize: 10,
        currentPage: 1,
        tableData: [],
        name:'',
        id:'',
        count:0,
        uploadData: {
          domain: 'EXAM',
          buz: 'EXCEL',
          expired: 60,
          actions: '',
          buzId: '123',
          auth: 1
        },
        uploadHeader: {
          ComId: 'ebiz-agent',
          Authorization: 'Basic ' + sessionStorage.getItem('token'),
          'Accept-Device': 'NULL',
          'Accept-DeviceOS': 'NULL',
          'Accept-Location': 'NULL',
          'Accept-ISP': 'NULL',
          'Accept-StartTime': 'NULL',
          'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
          'Accept-Attr1': getIP.getBrowserInfo(),
          'Accept-Attr2': 'PC',
          'Accept-Attr3': '',
          'Real-Ip': getIP.getBrowserInfo(),
          'Accept-Attr4': 'NULL',
          'Accept-Attr6': sessionStorage.getItem('username')
        },
        fileUrl: ''
      }
    },
    methods: {
      downloadTemp(){
        // 下载导入模板
        location.href = 'static/template/三要素鉴权模板.xls'
      },
      downloadResult(param) {
        // 下载结果
        location.href = api.urlDomin + param.result
      },
      uploadSuccess(res) {
        let that = this;
        if (res.result.isSuccess === true) {
          that.$refs.uploadAgent.clearFiles();
          // 上传完成，开始导入
          const loading = that.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          api.post(this.$url.checkThreeElementByFile, { filePath: api.urlDomin + res.data.fileId + '.' + res.data.ext }, function(res) {
            if (res.result.isSuccess === true){
             loading.close()
              that.currentPage = 1
              that.getCheckThreeElementHis()
            }
          });
        } else {
          that.$message.error(res.result.error);
          that.$refs.uploadAgent.clearFiles();
          // this.fileList = []
          // this.loading = false
        }
      },
      getCheckThreeElementHis () {
        let that = this


        let options = {
          currentPage: that.currentPage,
          pageSize: 10,
          // name:this.name,
          // id:this.id
        }
        api.post(this.$url.getThreeElementVerifyHis,options, function (res) {
          console.log(res)
          if (res.result.isSuccess === true) {
            that.tableData = []
            that.tableData = res.data.data
            that.count = Number(res.data.records)
            // loading.close()
          } else {
            // loading.close()
            alert('请求异常')
          }
        })
      },
      handleCurrentChange (val) {
        this.currentPage = val
        console.log(this.currentPage)
        this.getCheckThreeElementHis()
      },
    },
    mounted () {
      this.fileUrl = this.$uploadImg;
      let that = this
      // const loading = that.$loading({
      //   lock: true,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
      that.getCheckThreeElementHis()
    }

  }
</script>

<style lang="scss" scoped>
  #Activitypeople{
    padding-top: 60px;
    height:100%;
    box-sizing: border-box;
  }
  .ActivitypeopleCon{
    height: calc(100% - 100px);
    padding-top: 20px;
    // overflow: hidden;
    /* min-height: 100%; */
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }
  .contentRight{
    width:100%;
    float: left;
    // padding-top: 20px;
  }
  .rightcon{
    width: 96%;
    margin: 0 auto;
  }
  .tableCon{
    margin-top: 20px;
  }
  // .exportBtn{ margin-top: 20px;}
  .pages{
    display:flex;
    justify-content: center;
    align-items:center;
    background-color: #ffffff;
    height: 100px;
  }
  label{
    float: left;
    display: block;
    width: 31%;
    color: #919191;
  }

  .el-col {
    border-radius: 4px;
  }
  .pagesize{
    margin-bottom: 20px
  }
  #Activitypeople /deep/ .el-pagination{
    text-align: center!important
  }
  .search{
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth.vue